module.exports = __webpack_public_path__ + "img/plat_extended_logo.6eac5660.png";